import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { FilterDashboard, FilterLabelValue } from "../types/types";
import { dashboardMessages } from "../messages";

interface SelectProps {
  options: FilterDashboard[];
  value: string;
  labelValue?: FilterLabelValue;
  handleChange: (option: FilterDashboard) => void;
  showAsterik?: boolean;
}

export const Select = ({
  value,
  options,
  handleChange,
  labelValue,
  showAsterik = false,
}: SelectProps) => {
  const refSelect: any = useRef(null);
  const intl = useIntl();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    function handleClickOutside(e: any) {
      if (!refSelect.current.contains(e.target)) {
        setTimeout(() => {
          setOpen(false);
        }, 500);
      }
    }
    document.addEventListener("mousedown", handleClickOutside, true);
    document.addEventListener("scroll", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      document.removeEventListener("scroll", handleClickOutside, true);
    };
  }, [refSelect]);

  return (
    <div className="relative inline-block w-full max-h-[36px] cursor-pointer">
      <div>
        <div
          ref={refSelect}
          className="justify-between inline-flex w-full gap-x-1 rounded-md bg-white py-2 pl-3 pr-1 text-[16px] text-[#979CB1] ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          id="menu-button"
          aria-expanded="true"
          aria-haspopup="true"
          onClick={() => setOpen(true)}>
          <span className="truncate">
            {intl.formatMessage(dashboardMessages[value], labelValue || {})}
          </span>
          <svg width="31" height="23" viewBox="0 0 31 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_1_103" fill="white">
              <path d="M31 0H0V23H31V0Z"/>
            </mask>
            <path d="M1 0V23H-1V0H1Z" fill="#979CB1" mask="url(#path-1-inside-1_1_103)"/>
            <path d="M21.7138 7.80592C21.5306 7.61004 21.282 7.5 21.0229 7.5C20.7637 7.5 20.5152 7.61004 20.3319 7.80592L15.4941 12.9779L10.6563 7.80592C10.472 7.61559 10.2251 7.51027 9.96884 7.51266C9.71259 7.51504 9.46746 7.62492 9.28625 7.81865C9.10505 8.01237 9.00226 8.27443 9.00004 8.54839C8.99781 8.82235 9.09632 9.08628 9.27435 9.28334L14.8031 15.1941C14.9864 15.39 15.2349 15.5 15.4941 15.5C15.7533 15.5 16.0018 15.39 16.1851 15.1941L21.7138 9.28334C21.8971 9.0874 22 8.82169 22 8.54463C22 8.26757 21.8971 8.00186 21.7138 7.80592Z" fill="#979CB1" stroke="white" stroke-width="0.5"/>
          </svg>
        </div>
      </div>

      {open && (
        <div
          className="absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white shadow-sm ring-1 ring-black ring-opacity-5 focus:outline-none"
          role="menu">
          <div className="py-1" role="none">
            {options.map((option: FilterDashboard) => (
              <span
                key={`${option.value}${option.labelName}`}
                className="block px-4 py-2 text-sm text-[16px] hover:cursor-pointer hover:bg-[#EFF1F9]"
                role="menuitem"
                id={`${option.value}${option.labelName}`}
                onClick={e => {
                  e.preventDefault();
                  handleChange(option);
                }}>
                {intl.formatMessage(dashboardMessages[option.labelName], option.labelValue || {})}
                {showAsterik ? "*" : ""}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
